import React, { useCallback } from 'react';
import { arrayOf, bool, object } from 'prop-types';
import { Row as StickyRow } from 'react-sticky-table';
import { useNavigate } from 'react-router-dom';

import { abbreviateNumber } from '@ajaibid/utils';
import { Text } from 'Component/Ajaib';
import { TableColumn } from 'Component/Table';
import { FormatNumber, FormatRupiah, FormatPercentage } from 'Component/NumberFormat';
import SpecialNotation from 'Component/SpecialNotation';

import useEventTracker from '../tracker';
import { styTableRow, styTableCol, styCompanyLogo } from './style';

const DashboardStockContent = (props) => {
  const { isNotation, results } = props;
  const navigate = useNavigate();
  const { eventClickDetailPageStock } = useEventTracker();

  const getTableContents = useCallback(
    (result, idx) => {
      const change = result?.change_pct;
      const changePct = change * 100;
      const contents = [
        {
          text: (
            <>
              {result.icon_url && (
                <img
                  className={styCompanyLogo}
                  src={result.icon_url}
                  alt="logo"
                  loading="lazy"
                  data-testid={`divStockLogo-${idx}`}
                />
              )}
              <Text data-testid={`divStockContent-${idx}`}>{result.code}</Text>
            </>
          ),
          isNumber: false,
          isNotation: false,
        },
        {
          text: <SpecialNotation specialNotation={result.special_notations || []} totalShow={3} />,
          isNumber: false,
          isNotation: true,
        },
        {
          text: <Text>{abbreviateNumber(result.tradable_volume)}</Text>,
          isNumber: true,
          isNotation: false,
        },
        {
          text: (
            <Text>
              <FormatRupiah value={result.price} />
            </Text>
          ),
          isNumber: true,
          isNotation: false,
        },
        {
          text: (
            <>
              <Text bold positive={changePct > 0} negative={changePct < 0}>
                <FormatNumber decimalScale={0} value={result.change} isSymbol />{' '}
              </Text>
              <Text bold positive={changePct > 0} negative={changePct < 0}>
                (
                <FormatPercentage value={changePct} isSymbol />)
              </Text>
            </>
          ),
          isNumber: true,
          isNotation: false,
        },
      ];

      return isNotation ? contents : contents.filter((res) => !res.isNotation);
    },
    [isNotation, results]
  );

  return results.map((result, idx) => (
    <StickyRow
      className={styTableRow}
      key={result.code}
      data-key={result.code}
      onClick={(e) => {
        e.preventDefault();
        navigate(`/home/saham/${result.code}`);
        const eventProps = {
          'entry point': 'home',
          'stock code': result.code,
        };
        eventClickDetailPageStock(eventProps);
        e.stopPropagation();
      }}
    >
      {getTableContents(result, idx).map((content, idx2) => (
        <TableColumn
          as="sticky"
          size="small"
          isNumber={content.isNumber}
          className={styTableCol}
          key={`colStock-${idx}-${idx2}`}
        >
          {content.text}
        </TableColumn>
      ))}
    </StickyRow>
  ));
};

DashboardStockContent.propTypes = {
  isNotation: bool,
  results: arrayOf(object),
};

DashboardStockContent.defaultProps = {
  isNotation: false,
  results: [],
};

export default DashboardStockContent;
